import { guideSteps } from "@/mocks/mirrorData";

export default function Guide() {
  return (
    <section id="guide" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-sm text-secondary-900">
            <i className="ri-compass-3-line" /> 四步上手
          </span>
          <h2 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">使用指南</h2>
          <p className="mt-4 text-base leading-7 text-foreground-600">
            简单四步，轻松应对原站无法访问的情况，全程免费、无需注册。
          </p>
        </div>
        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {guideSteps.map((g, i) => (
            <div
              key={g.id}
              className="relative rounded-lg border border-background-200 bg-background-100/60 p-6"
            >
              <span className="absolute right-4 top-4 font-heading text-4xl text-background-300">
                0{i + 1}
              </span>
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-100 text-xl text-primary-600">
                <i className={g.icon} />
              </span>
              <h3 className="mt-5 text-base font-semibold text-foreground-950">{g.title}</h3>
              <p className="mt-2 text-sm leading-6 text-foreground-600">{g.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}